import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { Awaited } from 'ts-essentials';

import bulkRequestKeys from '@app/features/bulkRequest/queryKey';
import coalesceGlobalErrorMessage from '@app/libs/coalesceGlobalErrorMessage';
import { fetchRequestTasksStatus } from '@app/store/bulkRequest/requestTasks/status/actions';
import { reloadRequestTasks } from '@app/store/bulkRequest/requestTasks/tasks/actions';
import { modalOpen } from '@app/store/modal/actions';
import { postBulkRequestsCancel } from '@app/store/transport-layer/bulk-request/bulk-requests/cancel';

const useCancelBulkRequest = (id: string) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation<
    Awaited<ReturnType<typeof postBulkRequestsCancel>>,
    AxiosError,
    Parameters<typeof postBulkRequestsCancel>
  >(
    bulkRequestKeys.mutation.cancel(id),
    async ([workspaceId, bulkRequestId, data]) =>
      postBulkRequestsCancel(workspaceId, bulkRequestId, data),
    {
      onSuccess: (_, [, bulkRequestId]) => {
        queryClient.invalidateQueries(bulkRequestKeys.query.byId(bulkRequestId));

        dispatch(fetchRequestTasksStatus(bulkRequestId));
        dispatch(reloadRequestTasks(bulkRequestId));
      },
      onError: (error) => {
        dispatch(
          modalOpen('CONFIRM', {
            title: '일괄 요청 취소 실패',
            content: coalesceGlobalErrorMessage(error.message),
          })
        );
      },
    }
  );
};

export default useCancelBulkRequest;
